import { MdAdd } from 'react-icons/md';

import { Button, Group } from '@ui';

type AddMoreButtonProps = {
  disabled?: boolean;
  ctaText?: string;
  handleAdd: () => void;
};

/**
 *
 * @description Use this with ArrayForms.
 */
const AddMoreButton = ({ disabled, ctaText, handleAdd }: AddMoreButtonProps) => {
  return (
    <Group justify="flex-end">
      <Button
        disabled={disabled}
        size="sm"
        leftSection={<MdAdd color="#389BF5" />}
        onClick={handleAdd}
        color="secondary"
      >
        {ctaText ? ctaText : 'Add more'}
      </Button>
    </Group>
  );
};

export { AddMoreButton };
